
import React, { useEffect, useState } from "react";
import "../Styles/paymentSuccess.css";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Header from "./Header";
import Footer from "./Footer";

const api = process.env.REACT_APP_API_URL;

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const sessionId = searchParams.get("session_id");

  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [wristbandId, setWristbandId] = useState("");

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const { data } = await axios.get(
          `${api}/verify-payment?session_id=${sessionId}`
        );

        if (data.success) {
          setEmail(data.customerEmail);
          setWristbandId(data.wristbandId);
        }
      } catch (err) {
        toast.error(
          err.response?.data?.message || "Unable to verify payment."
        );
      } finally {
        setLoading(false);
      }
    };

    if (sessionId) {
      verifyPayment();
    }
  }, [sessionId]);

  const handleSetup = () => {
    navigate(
      `/signup?email=${encodeURIComponent(email)}&wristbandId=${encodeURIComponent(
        wristbandId
      )}`
    );
  };

  if (loading) {
    return (
      <div className="success-container">
        <div className="success-card">
          <h2>Verifying your payment...</h2>
        </div>
      </div>
    );
  }

  return (
    
    <>
<Header/>
    <div className="success-container">
      <div className="success-card">

        <div className="success-icon">✓</div>

        <h1>Payment Successful</h1>

        <p className="success-subtitle">
          Welcome to ClusterClear. Your wristband has been created and is ready
          to be set up.
        </p>

        <div className="success-box">
          <span>Your Wristband ID</span>
          <h2>{wristbandId}</h2>
        </div>

        <div className="success-email">
          <span>Purchased with</span>
          <p>{email}</p>
        </div>

        <button className="success-btn" onClick={handleSetup}>
          Let's Set Up My Wristband
        </button>

        <p className="success-note">
          Keep your wristband ID safe. You'll need it if you ever need to recover
          or reconnect your wristband.
        </p>

      </div>
    </div>
    <Footer/>
        </>
  );
}